import React from 'react';
import propTypes from 'prop-types';

import Styles from './Check.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';

export default function Check({ value, setter }) {
  const { Check, Checked } = Styles;
  return (
    <div onClick={setter} className={Check}>
      <FontAwesomeIcon
        className={value ? Checked : ''}
        icon={value ? faToggleOn : faToggleOff}
      />
    </div>
  );
}

Check.propTypes = {
  value: propTypes.bool.isRequired,
  setter: propTypes.func.isRequired,
};
